interface IMapper<T> {
	toDomain(): T;
}

export abstract class Mapper<T> implements IMapper<T> {
	toDomain(): T {
		throw new Error('Method not implemented.');
	}
}
